export default __webpack_public_path__ + "static/media/BROWNBOOK.1d753732.png";